import { render, staticRenderFns } from "./MorphologicCodeGrid.vue?vue&type=template&id=c0ed2028&scoped=true&"
import script from "./MorphologicCodeGrid.ts?vue&type=script&lang=ts&"
export * from "./MorphologicCodeGrid.ts?vue&type=script&lang=ts&"
import style0 from "./MorphologicCodeGrid.scss?vue&type=style&index=0&id=c0ed2028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ed2028",
  null
  
)

export default component.exports